/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { z } from 'zod/mini'

import type { Equal, ExpectTrue } from '../types/validation'

import { type ContentLink, ContentLinkSchema } from './content-link'
import { type Image, ImageSchema } from './image'

/* TypeScript */
export type Category = {
  id: string
  title: string
  tagline?: Maybe<string>
  image: Image
  link?: Maybe<ContentLink>
}

export type CategoryWithLink = Category & { link: ContentLink }

export type CategoriesApiProps = {
  technicalName?: Maybe<string>
  title?: Maybe<string>
  subtitle?: Maybe<string>
  categories: Category[]
}

/* Schemas */
export const CategorySchema = z.object({
  id: z.string(),
  title: z.string(),
  tagline: z.nullish(z.string()),
  image: ImageSchema,
  link: z.nullish(ContentLinkSchema),
})

export const CategoryWithLinkSchema = z.intersection(
  z.object({
    link: ContentLinkSchema,
  }),
  CategorySchema,
)

export const CategoriesApiPropsSchema = z.object({
  technicalName: z.nullish(z.string()),
  title: z.nullish(z.string()),
  subtitle: z.nullish(z.string()),
  categories: z.array(CategorySchema),
})

/* Schemas validation */
type TestCategoriesProps = ExpectTrue<
  Equal<CategoriesApiProps, z.infer<typeof CategoriesApiPropsSchema>>
>
